import { HttpStatusCode, isAxiosError } from "axios";

type ProgressPageAvailability = {
  careplanError: unknown;
  isCareplanResolved: boolean;
  isProgressEnabled: boolean;
  progressError: unknown;
};

export const isNotFoundError = (error: unknown) => {
  return isAxiosError(error) && error.response?.status === HttpStatusCode.NotFound;
};

export const shouldLeaveProgressPage = ({
  careplanError,
  isCareplanResolved,
  isProgressEnabled,
  progressError,
}: ProgressPageAvailability) => {
  if (isNotFoundError(careplanError) || isNotFoundError(progressError)) {
    return true;
  }

  return isCareplanResolved && !isProgressEnabled;
};
